import {
  Col,
  message,
  PageHeader,
  Row,
  Spin,
  Select,
  Space,
  Tabs,
  Radio,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { connect } from "react-redux";
import {
  SelectItem,
  Form,
  FormItem,
  cuentaMask,
  RangePickerItem,
  TableItem,
  dineroDisabledMask,
  ButtonItem,
  ErrorItem,
} from "../../../../Components/Items";
import reporteDeNotasDeCreditoCompraPdf from "../../../../Pdf/reporteDeNotasDeCreditoCompraPdf";
import { FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import { ResponsiveLine } from "@nivo/line";
import moment from "moment";
import "moment/locale/es";
moment.locale("es");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Option } = Select;
const { TabPane } = Tabs;

class ReporteNotasDeCreditoCompra extends Component {
  state = {
    loading: false,
    objetoProveedores: null,
    todasProveedores: null,
    objetoProyectos: null,
    todasProyectos: null,
    objetoUniadesDeNegocio: null,
    todasUniadesDeNegocio: null,
    dataReporte: null,
    todasNotas: [],
    dataGrafico: [],
    campoGrafico: "subtotal",
    totalesPorMoneda: {},
  };

  atras() {
    this.props.history.goBack();
  }

  async componentDidMount() {
    this.setState({ loading: true });
    const campoGraficoGuardado = localStorage.getItem(`graficoCampo_ReporteNotasDeCreditoCompra_${this.props.empresaId}`);
    if (campoGraficoGuardado === "subtotal" || campoGraficoGuardado === "totalPagar") {
      this.setState({ campoGrafico: campoGraficoGuardado });
    }

    await Promise.all([
      axios.post(
        "proveedores/selectProveedores",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      ).then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            todasProveedores: res.data,
            objetoProveedores: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {value.stringBuscar}
              </Option>
            )),
          });
        }
      }),

      axios.post(
        "proyectos/selectProyectos",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      ).then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            todasProyectos: res.data,
            objetoProyectos: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {value.nombre}
              </Option>
            )),
          });
        }
      }),

      axios.post(
        "unidadesdenegocio/selectUnidadesDeNegocio",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      ).then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            todasUniadesDeNegocio: res.data,
            objetoUniadesDeNegocio: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {cuentaMask(
                  value.nivel1 + value.nivel2 + value.nivel3 +
                  value.nivel4 + value.nivel5
                ) + " - " + value.nombre}
              </Option>
            )),
          });
        }
      }),
    ]);

    this.consultarReporteNotasDeCreditoCompra({
      periodo: [moment().subtract(1, "month"), moment()],
      proveedores: 0,
      filtrarProyecto: 0,
      estadoNotas: 1,
    });
  }

  async crearGrafico(valueNotas, fechaInicial, fechaFinal, campoGrafico = this.state.campoGrafico) {
    let grafico = [];
    let graficoSumatoria = [];
    let sumatoria = 0;

    let fechaCambiante = moment(fechaInicial).locale("es");
    const fechaFinalMoment = moment(fechaFinal).locale("es");

    const acumular = (unidad) => {
      while (fechaFinalMoment.diff(fechaCambiante, unidad) !== -1) {
        // eslint-disable-next-line no-loop-func
        const notas = valueNotas.filter((nota) => {
          if (isNaN(nota.fechaFactura)) {
            return moment(fechaCambiante).isSame(
              moment(nota.fechaFactura, "DD/MM/YYYY"),
              unidad === "days" ? "date" : unidad.replace(/s$/, "")
            );
          } else {
            return false;
          }
        });

        let totalPagar = 0;
        notas.forEach((valueNotaDia) => {
          const tc = valueNotaDia.tipoDeCambio || 1;
          totalPagar += (valueNotaDia[campoGrafico] || 0) * tc;
        });

        grafico.push({
          x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
          y: totalPagar,
        });
        graficoSumatoria.push({
          x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
          y: totalPagar + sumatoria,
        });

        sumatoria += totalPagar;
        fechaCambiante = moment(fechaCambiante).add(1, unidad).locale("es");
      }
    };

    if (fechaFinalMoment.diff(fechaCambiante, "days") <= 31) {
      acumular("days");
    } else if (fechaFinalMoment.diff(fechaCambiante, "days") < 180) {
      acumular("weeks");
    } else if (fechaFinalMoment.diff(fechaCambiante, "months") < 36) {
      acumular("months");
    } else {
      acumular("years");
    }

    await this.setState({
      dataGrafico: [
        {
          id: "Notas de Credito",
          color: "#DC2626",
          data: grafico,
        },
        {
          id: "Notas de Credito Acumuladas",
          color: "#FCA5A5",
          data: graficoSumatoria,
        },
      ],
    });
  }

  onChangeCampoGrafico = (campoGrafico) => {
    this.setState({ campoGrafico });
    localStorage.setItem(`graficoCampo_ReporteNotasDeCreditoCompra_${this.props.empresaId}`, campoGrafico);
    if (this.state.dataReporte) {
      this.crearGrafico(
        this.state.todasNotas,
        this.state.dataReporte.fechaInicial,
        this.state.dataReporte.fechaFinal,
        campoGrafico
      );
    }
  };

  consultarReporteNotasDeCreditoCompra(values) {
    this.setState({ loading: true });
    axios
      .post(
        "reportesDeCompras/reporteNotasDeCreditoCompra",
        { ...values, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.crearGrafico(
            res.data.notas,
            res.data.fechaInicial,
            res.data.fechaFinal
          );
          const totalesPorMoneda = {};
          (res.data.notas || []).filter(v => v.folio !== '').forEach(nota => {
            const moneda = nota.moneda || 'Sin Moneda';
            if (!totalesPorMoneda[moneda]) {
              totalesPorMoneda[moneda] = { subtotal: 0, totalImpuestos: 0, total: 0, totalRetenciones: 0, totalACobrar: 0 };
            }
            totalesPorMoneda[moneda].subtotal += nota.subtotal || 0;
            totalesPorMoneda[moneda].totalImpuestos += nota.totalImpuestos || 0;
            totalesPorMoneda[moneda].total += nota.total || 0;
            totalesPorMoneda[moneda].totalRetenciones += nota.totalRetenciones || 0;
            totalesPorMoneda[moneda].totalACobrar += nota.totalPagar || 0;
          });
          this.setState({
            loading: false,
            dataReporte: res.data,
            todasNotas: res.data.notas,
            totalesPorMoneda,
          });
        } else {
          message.error("Ha sucedido un error y no se cargo bien el reporte");
        }
        this.setState({ loading: false });
      });
  }

  descargarExcel() {
    const parseFecha = (val) => {
      if (!val) return val;
      const m = moment(val, "DD/MM/YYYY", true);
      return m.isValid() ? new Date(Date.UTC(m.year(), m.month(), m.date(), 12, 0, 0)) : val;
    };
    const columnasFecha = ["Fecha"];
    const datosDescargar = this.state.todasNotas.map((valueNota) => {
      return {
        "Folio": valueNota.folio,
        "Factura de Origen": valueNota.folioOrigen,
        "Codigo Proveedor": valueNota.codigoProveedor,
        "Clave Proveedor": valueNota.claveProveedor,
        "Fecha": parseFecha(valueNota.fechaFactura),
        Proveedor: valueNota.proveedor,
        "Proyecto": valueNota.proyecto ? valueNota.proyecto : '',
        "Razon Social": valueNota.razonSocial,
        "Descripcion": valueNota.descripcion,
        SubTotal: valueNota.subtotal,
        Impuestos: valueNota.totalImpuestos,
        "Retenciones": valueNota?.totalRetenciones,
        Total: valueNota.total,
        "Total A Devolver": valueNota.totalPagar,
        Moneda: valueNota.moneda,
        "Tipo de Cambio": valueNota.tipoDeCambio,
        "Folio Fiscal": valueNota.folioFiscal,
        Abonos: valueNota.totalPagado,
        Saldo: valueNota.saldo,
        Estado: valueNota.estado,
      };
    });
    const worksheet = XLSX.utils.json_to_sheet(datosDescargar, { cellDates: true });
    if (worksheet["!ref"]) {
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      const indicesFecha = [];
      for (let C = range.s.c; C <= range.e.c; C++) {
        const header = worksheet[XLSX.utils.encode_cell({ r: range.s.r, c: C })];
        if (header && columnasFecha.includes(header.v)) {
          indicesFecha.push(C);
        }
      }
      for (let R = range.s.r + 1; R <= range.e.r; R++) {
        for (const C of indicesFecha) {
          const cell = worksheet[XLSX.utils.encode_cell({ r: R, c: C })];
          if (cell && cell.v instanceof Date) {
            cell.t = "d";
            cell.z = "dd/mm/yyyy";
          }
        }
      }
    }
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Reporte Notas Credito");
    XLSX.writeFile(workbook, `Reporte_De_Notas_De_Credito_Compra_${moment().locale("es").format("L")}.xlsx`);
  }

  descargarPdf() {
    pdfMake
      .createPdf(reporteDeNotasDeCreditoCompraPdf(this.state.dataReporte))
      .download(`Reporte_De_Notas_De_Credito_Compra_${moment().locale("es").format("L")}`);
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  render() {
    const columns = [
      {
        title: "Folio",
        dataIndex: "folio",
        key: "folio",
        sorter: (a, b) => {
          if (a.folio < b.folio) return -1;
          if (a.folio > b.folio) return 1;
          return 0;
        },
        buscar: "folio",
        ellipsis: true,
      },
      {
        title: "Fecha",
        dataIndex: "fechaFactura",
        key: "fechaFactura",
        sorter: (a, b) => {
          if (moment(a.fechaFactura, "DD/MM/YYYY") < moment(b.fechaFactura, "DD/MM/YYYY")) return -1;
          if (moment(a.fechaFactura, "DD/MM/YYYY") > moment(b.fechaFactura, "DD/MM/YYYY")) return 1;
          return 0;
        },
        defaultSortOrder: "ascend",
        buscar: "fechaFactura",
        ellipsis: true,
      },
      {
        title: "Factura Origen",
        dataIndex: "folioOrigen",
        key: "folioOrigen",
        sorter: (a, b) => {
          if ((a.folioOrigen || "") < (b.folioOrigen || "")) return -1;
          if ((a.folioOrigen || "") > (b.folioOrigen || "")) return 1;
          return 0;
        },
        buscar: "folioOrigen",
        ellipsis: true,
      },
      {
        title: "Proveedor",
        dataIndex: "proveedor",
        key: "proveedor",
        sorter: (a, b) => {
          if (a.proveedor < b.proveedor) return -1;
          if (a.proveedor > b.proveedor) return 1;
          return 0;
        },
        buscar: "proveedor",
        ellipsis: true,
      },
      {
        title: "Total",
        dataIndex: "totalPagar",
        key: "totalPagar",
        sorter: (a, b) => {
          if (a.totalPagar < b.totalPagar) return -1;
          if (a.totalPagar > b.totalPagar) return 1;
          return 0;
        },
        buscar: "totalPagar",
        render: (value) => dineroDisabledMask(value),
        align: "right",
        ellipsis: true,
      },
      {
        title: "Aplicado",
        dataIndex: "totalPagado",
        key: "totalPagado",
        sorter: (a, b) => {
          if (a.totalPagado < b.totalPagado) return -1;
          if (a.totalPagado > b.totalPagado) return 1;
          return 0;
        },
        buscar: "totalPagado",
        render: (value) => dineroDisabledMask(value),
        align: "right",
        ellipsis: true,
      },
      {
        title: "Saldo",
        dataIndex: "saldo",
        key: "saldo",
        sorter: (a, b) => {
          if (a.saldo < b.saldo) return -1;
          if (a.saldo > b.saldo) return 1;
          return 0;
        },
        buscar: "saldo",
        render: (value) => dineroDisabledMask(value),
        align: "right",
        ellipsis: true,
      },
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
        sorter: (a, b) => {
          if (a.estado < b.estado) return -1;
          if (a.estado > b.estado) return 1;
          return 0;
        },
        buscar: "estado",
        ellipsis: true,
      },
    ];

    return (
      <>
        <Form
          ref={this.formRef}
          name="reporteNotasDeCreditoCompra"
          onFinish={this.consultarReporteNotasDeCreditoCompra.bind(this)}
          onFinishFailed={this.onFinishFailed}
          initialValues={{
            periodo: [moment().subtract(1, "month"), moment()],
          }}
        >
          <PageHeader
            onBack={this.atras.bind(this)}
            title="Reporte Notas de Credito de Compra"
            style={{
              border: "1px solid rgb(235, 237, 240)",
              backgroundColor: "white",
              marginBottom: 10,
            }}
            extra={
              <div style={{ display: "flex", justifyContent: "right" }}>
                <Space>
                  {this.state.dataReporte && (
                    <ButtonItem
                      blanco
                      onClick={() => this.descargarExcel()}
                      icon={<FileExcelOutlined />}
                      style={{ display: "block", margin: "0 0 0 auto" }}
                    >
                      Descargar Excel
                    </ButtonItem>
                  )}
                  {this.state.dataReporte && (
                    <ButtonItem
                      blanco
                      onClick={() => this.descargarPdf()}
                      icon={<FilePdfOutlined />}
                      style={{ display: "block", margin: "0 0 0 auto" }}
                    >
                      Descargar PDF
                    </ButtonItem>
                  )}
                  <ButtonItem
                    type="primary"
                    htmlType="submit"
                    style={{ display: "block", margin: "0 0 0 auto" }}
                  >
                    Consultar
                  </ButtonItem>
                </Space>
              </div>
            }
          />
          <Spin spinning={this.state.loading}>
            <div
              style={{
                backgroundColor: "white",
                padding: 20,
                paddingTop: 5,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <Tabs
                style={{ margin: 0 }}
                tabBarExtraContent={{
                  left: (
                    <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>
                      Filtros:
                    </h1>
                  ),
                }}
              >
                <TabPane tabKey="1" key="1" forceRender tab="Periodo">
                  <FormItem name="periodo" required noStyle>
                    <RangePickerItem />
                  </FormItem>
                </TabPane>
                <TabPane tabKey="2" key="2" forceRender tab="Proveedores">
                  <FormItem name="proveedores" noStyle margin>
                    <SelectItem
                      width="90%"
                      mode="multiple"
                      placeholder="Proveedores"
                    >
                      {this.state.objetoProveedores}
                    </SelectItem>
                  </FormItem>
                </TabPane>
                <TabPane tabKey="3" key="3" forceRender tab="Proyecto">
                  <Row>
                    <Col span={8}>
                      <FormItem
                        name="filtrarProyecto"
                        required
                        noStyle
                        initialValue={0}
                      >
                        <SelectItem width="90%" placeholder="Filtrar Proyecto">
                          <Option default value={0}>
                            Niguno
                          </Option>
                          <Option value={1}>Proyectos</Option>
                          <Option value={2}>Unidades de negocio</Option>
                        </SelectItem>
                      </FormItem>
                    </Col>
                    <Col span={8}>
                      <FormItem shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          const filtrarProyecto =
                            getFieldValue("filtrarProyecto");
                          if (filtrarProyecto === 1) {
                            return (
                              <FormItem required name="proyectos" margin noStyle>
                                <SelectItem
                                  width="90%"
                                  placeholder="Proyectos"
                                  mode="multiple"
                                >
                                  {this.state.objetoProyectos}
                                </SelectItem>
                              </FormItem>
                            );
                          }
                          if (filtrarProyecto === 2) {
                            return (
                              <FormItem required margin name="unidadDeNegocioId" noStyle>
                                <SelectItem
                                  width="90%"
                                  placeholder="Unidades de Negocio"
                                >
                                  {this.state.objetoUniadesDeNegocio}
                                </SelectItem>
                              </FormItem>
                            );
                          }
                        }}
                      </FormItem>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tabKey="4" key="4" forceRender tab="Detalles">
                  <Row style={{ padding: 0, margin: 0 }} gutter={[16, 0]}>
                    <Col span={8}>
                      <FormItem
                        label="Estado"
                        name="estadoNotas"
                        required
                        initialValue={1}
                        style={{ marginBottom: 0 }}
                      >
                        <SelectItem placeholder="Filtrar Por">
                          <Option default value={1}>
                            Activas
                          </Option>
                          <Option value={2}>Canceladas</Option>
                          <Option value={0}>Todas (Activas y Canceladas)</Option>
                        </SelectItem>
                      </FormItem>
                    </Col>
                  </Row>
                </TabPane>
              </Tabs>
            </div>
            <div
              style={{
                backgroundColor: "white",
                padding: 20,
                paddingBottom: 35,
                marginTop: 10,
                marginBottom: 10,
                height: 420,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 10 }}>
                <h1 style={{ fontSize: 18, margin: 0 }}>Gráfico</h1>
                <Radio.Group
                  size="small"
                  value={this.state.campoGrafico}
                  onChange={(e) => this.onChangeCampoGrafico(e.target.value)}
                >
                  <Radio.Button value="subtotal">Subtotal</Radio.Button>
                  <Radio.Button value="totalPagar">Total a Pagar</Radio.Button>
                </Radio.Group>
              </div>

              <ResponsiveLine
                data={this.state.dataGrafico}
                margin={{ top: 15, right: 20, bottom: 70, left: 100 }}
                enableSlices="x"
                useMesh={true}
                yFormat={(e) => dineroDisabledMask(Math.abs(e))}
                xScale={{ type: "point" }}
                yScale={{
                  type: "linear",
                  min: 0,
                  max: "auto",
                  stacked: false,
                  reverse: false,
                }}
                curve="monotoneX"
                lineWidth={2}
                pointSize={5}
                pointBorderWidth={1}
                pointColor={{ theme: "background" }}
                pointBorderColor={{ from: "serieColor" }}
                colors={["#DC2626", "#FCA5A5"]}
                colorBy="index"
                axisTop={null}
                axisRight={null}
                axisBottom={{
                  tickSize: 5,
                  tickPadding: 8,
                  tickRotation: 45,
                  tickValues: (this.state.dataGrafico?.[0]?.data || [])
                    .map(d => d.x)
                    .filter((_, i) => i % 2 === 0),
                }}
                axisLeft={{
                  tickSize: 5,
                  tickPadding: 8,
                  format: (v) => dineroDisabledMask(Math.abs(v)),
                }}
                enableGridX={false}
                legends={[
                  {
                    anchor: "top",
                    direction: "row",
                    translateX: 0,
                    translateY: -15,
                    itemWidth: 180,
                    itemHeight: 18,
                    symbolSize: 10,
                    symbolShape: "circle",
                    itemOpacity: 0.85,
                    effects: [
                      {
                        on: "hover",
                        style: {
                          itemOpacity: 1,
                        },
                      },
                    ],
                  },
                ]}
              />
            </div>
            <div
              style={{
                backgroundColor: "white",
                padding: 15,
                marginBottom: 10,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              {Object.entries(this.state.totalesPorMoneda).map(([moneda, totales], idx, arr) => (
                <div key={moneda} style={{ marginBottom: arr.length > 1 && idx < arr.length - 1 ? 8 : 0 }}>
                  {arr.length > 1 && (
                    <p style={{ margin: "0 0 2px 8px", fontWeight: 700, fontSize: 13, color: "#00BFD6" }}>
                      {moneda}
                    </p>
                  )}
                  <Row>
                    <Col span={4} style={{ textAlign: "center" }}>
                      <p style={{ margin: 0 }}>{arr.length === 1 ? `Subtotal (${moneda})` : "Subtotal"}</p>
                      <h1 style={{ fontSize: 15 }}>{dineroDisabledMask(totales.subtotal)}</h1>
                    </Col>
                    <Col span={1} style={{ textAlign: "center" }}>
                      <h1 style={{ fontSize: 20 }}>+</h1>
                    </Col>
                    <Col span={4} style={{ textAlign: "center" }}>
                      <p style={{ margin: 0 }}>Impuestos</p>
                      <h1 style={{ fontSize: 15 }}>{dineroDisabledMask(totales.totalImpuestos)}</h1>
                    </Col>
                    <Col span={1} style={{ textAlign: "center" }}>
                      <h1 style={{ fontSize: 20 }}>=</h1>
                    </Col>
                    <Col span={4} style={{ textAlign: "center" }}>
                      <p style={{ margin: 0 }}>Total</p>
                      <h1 style={{ fontSize: 15 }}>{dineroDisabledMask(totales.total)}</h1>
                    </Col>
                    <Col span={1} style={{ textAlign: "center" }}>
                      <h1 style={{ fontSize: 20 }}>-</h1>
                    </Col>
                    <Col span={4} style={{ textAlign: "center" }}>
                      <p style={{ margin: 0 }}>Retenciones</p>
                      <h1 style={{ fontSize: 15 }}>{dineroDisabledMask(totales.totalRetenciones)}</h1>
                    </Col>
                    <Col span={1} style={{ textAlign: "center" }}>
                      <h1 style={{ fontSize: 20 }}>=</h1>
                    </Col>
                    <Col span={4} style={{ textAlign: "center" }}>
                      <p style={{ margin: 0 }}>Total Devolver</p>
                      <h1 style={{ fontSize: 15 }}>{dineroDisabledMask(totales.totalACobrar)}</h1>
                    </Col>
                  </Row>
                  {arr.length > 1 && idx < arr.length - 1 && (
                    <hr style={{ margin: "6px 0", borderColor: "#f0f0f0" }} />
                  )}
                </div>
              ))}
            </div>
            <TableItem
              onRow={(record) => {
                return {
                  onDoubleClick: () => {
                    this.props.history.push("/panel/verNotaDeCreditoCompra", {
                      id: record._id,
                    });
                  },
                };
              }}
              rowKey={(value) => value._id.toString() + Math.random()}
              columns={columns}
              dataSource={this.state.todasNotas}
              size="small"
              pagination={false}
            />
          </Spin>
        </Form>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(ReporteNotasDeCreditoCompra);
